import { AfterViewInit, Directive, ElementRef, Input } from '@angular/core';

@Directive({
  selector: '[setContainerHeightByAspectRatio]',
})
export class SetContainerHeightByAspectRatioDirective implements AfterViewInit {
  @Input() aspectRatio: number;

  constructor(private el: ElementRef) {}

  ngAfterViewInit(): void {
    if (this.el && this.aspectRatio) {
      this.el.nativeElement.style.height =
        this.el.nativeElement.offsetWidth * this.aspectRatio + 'px';
      this.el.nativeElement.style.minHeight =
        this.el.nativeElement.offsetWidth * this.aspectRatio + 'px';
    }
  }
}
